import { render, staticRenderFns } from "./InventoryTransactionReport.vue?vue&type=template&id=407c6e21"
import script from "./InventoryTransactionReport.vue?vue&type=script&lang=js"
export * from "./InventoryTransactionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports